import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";
import Vue from "vue";

import { UserAvatar } from "@/modules/avatars/viewmodels/UserAvatar";

export const state = {
  avatar: {},
};

export const getters = Object.assign(
  {
    avatar: (state) => {
      return state.avatar;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/users-avatars",
    UserAvatar,
    {},
    {
      /**
       * Update own avatar
       * this.$store.getters['useravatar/api'].Custom.Update()
       */
      Update: async (Payload) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/users-avatars/",
          Payload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        return ApiResult.data.filename;
      },
    }
  )
);

// mutations
export const mutations = {
  updateAvatar: (state, Avatar) => {
    Vue.set(state, "avatar", Avatar);
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/users-avatars",
  [],
  {
    async updateAvatar({ commit }, Avatar) {
      commit("updateAvatar", Avatar);
    },
  }
);
